const INITIAL_STATE = {
  data: {},
  errors: {},
        
}
const updateUser= (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'UPDATE_USER_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'UPDATE_USER_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
        
export default updateUser;